import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ItemContainer } from "./ItemContainer";
import { useApi } from "../Context/ApiProvider";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Divider } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";

// Main LastArticles component
export default function LastArticles() {
  const { t } = useTranslation();
  const [posts, setPosts] = useState([]);
  const [isLgScreen, setIsLgScreen] = useState(false);
  const api = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const resPosts = await api.uget("/api/blog/posts?");
      if (resPosts.ok && resPosts.body && resPosts.body.results) {
        const fetchedPosts = resPosts.body.results.map((item) => ({
          id: item.id,
          name: item.title,
          image: item.featured_image ? item.featured_image.url : null,
          text: item.excerpt,
          lastPublishedAt: item.last_published_at,
        }));
        setPosts(fetchedPosts);
      }
    })();
  }, [api]);

  useEffect(() => {
    const handleResize = () => {
      setIsLgScreen(window.innerWidth >= 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBlogPage = (blogId) => {
    const lng = localStorage.getItem("lng");
    const newPath = `/blog-detail/${lng}/${blogId}`;
    console.log(newPath);
    navigate(newPath);
  };

  return (
    <>
      <div className="text-2xl  lg:w-[60%] m-auto p-5 lg:p-0">
        <div className="flex flex-col items-center justify-center">
          <h2 className="font-bold text-4xl mt-6 lg:mt-0 ">
            {t("lastArticlesTitle")}
          </h2>
          <Divider className="bg-red-600 w-52 2xl:w-[15%] h-1  mb-5 mt-4" />
        </div>
        <div
          className={`hidden md:flex gap-10 lg:gap-5 2xl:gap-0  w-full mt-10 cursor-pointer ${
            localStorage.getItem("lng") === "fa"
              ? "relative 2xl:right-9"
              : localStorage.getItem("lng") === "en"
              ? "relative 2xl:left-9"
              : ""
          }`}
        >
          {[posts?.[0], posts?.[1]]?.map((item, index) =>
            item ? (
              <div
                key={item.id || index}
                onClick={() => handleBlogPage(item.id)}
              >
                <img
                  alt=""
                  src={item.image}
                  className=" w-full !h-80 2xl:w-[90%] rounded-lg"
                />
                <div className="grid bg-white shadow-2xl relative z-30   rounded-b-lg  p-5 -top-12 2xl:w-[90%]">
                  <h1 className="bordr-b-2 border-black text-[17px] lg:text-[16px] xl:text-[20px] font-bold  ">
                    {item.name}
                  </h1>
                  <Divider className="mt-2 mb-2  " />

                  <p className="md:text-[16px] text-[12px] text-gray-600">
                    {item.text}
                  </p>
                </div>
              </div>
            ) : null
          )}
        </div>

        <Swiper
          dir="rtl"
          cssMode={isLgScreen ? "true" : "false"}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 10 },
            640: { slidesPerView: 2, spaceBetween: 15 },
            1440: { slidesPerView: 3, spaceBetween: 15 },
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          modules={[Pagination, Autoplay]}
          pagination={{ dynamicBullets: true }}
          className=" cursor-pointer mt-5"
        >
          {posts?.map((item) => (
            <SwiperSlide key={item.id}>
              <ItemContainer
                topic={item.name}
                text={item.text}
                img={item.image}
                blogPost={item}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}
